import { FC } from 'react'

import { useSelector } from 'react-redux'

import SurveyForEndedCampaign from 'src/Components/SideBarSurveys/SurveyForEndedCampaign'
import { getValueOrEmptyString } from 'src/Helpers/layoutHelpers'
import { CampaignStatusEnum } from 'src/Types/campaigns'
import { getClosedTypeformIds } from 'src/Redux/typeform-process'
import { useSpotifyCampaignDetails } from 'src/Redux/campaignDetailsApi/useSpotifyCampaignDetails'
import { useAppSelector } from 'src/Hooks/redux'
import { getUserEmail } from 'src/Redux/auth-process/userSlice/selectors'
export const Survey: FC = () => {
  const closedTypeformIds = useSelector(getClosedTypeformIds)
  const { campaignDetails } = useSpotifyCampaignDetails()
  const userEmail = useAppSelector(getUserEmail)

  const isAppropriateCampaignStatus =
    campaignDetails?.status &&
    campaignDetails?.status === CampaignStatusEnum.ENDED

  const isClosedCampaign = Boolean(
    closedTypeformIds.includes(campaignDetails?.id?.toString() ?? ''),
  )

  if (!isAppropriateCampaignStatus || isClosedCampaign) {
    return null
  }

  return (
    <SurveyForEndedCampaign
      userEmail={userEmail}
      campaignId={`${campaignDetails?.id ?? ''}`}
      campaignType={`${getValueOrEmptyString(campaignDetails?.type)}`}
      campaignName={`${getValueOrEmptyString(
        campaignDetails?.Track?.trackName,
      )}`}
      matchingType={`${campaignDetails?.matchingType}`}
      isFeed
      id='VP92h7z5'
      text='Share feedback'
    />
  )
}
